import { createSlice } from '@reduxjs/toolkit';

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    token: null,
    isLoginSuccess: false,
    isLoginInfoError: false,
    userInfo: null,
    isResetPasswordTokenSuccess: false,
    availabilityInfo: null,
    isResetPasswordSuccess: false,
  },
  reducers: {
    executeLogin: (state) => {
      state.isLoginSuccess = null;
    },
    executeLoginSuccess: (state, action) => {
      state.token = action.payload;
      state.isLoginSuccess = true;
    },
    executeLoginFailure: (state) => {
      state.token = '';
      state.isLoginSuccess = false;
    },
    clearLoginInfo: (state) => {
      state.userInfo = null;
      state.isLoginInfoError = false;
      state.isLoginSuccess = null;
      state.token = '';
    },
    executeGetLoginInfo: (state) => {
      state.isLoginInfoError = false;
    },
    executeGetLoginInfoSuccess: (state, action) => {
      state.userInfo = action.payload;
      state.isLoginInfoError = false;
    },
    executeGetLoginInfoFailure: (state) => {
      state.userInfo = null;
      state.isLoginInfoError = true;
    },
    resetPasswordToken: (state) => {
      state.isResetPasswordTokenSuccess = false;
    },
    resetPasswordTokenSuccess: (state) => {
      state.isResetPasswordTokenSuccess = true;
    },
    getResetPasswordToken: (state) => {
      state.availabilityInfo = null;
    },
    getResetPasswordTokenSuccess: (state, action) => {
      state.availabilityInfo = action.payload;
    },
    resetPassword: (state) => {
      state.isResetPasswordSuccess = false;
    },
    resetPasswordSuccess: (state) => {
      state.isResetPasswordSuccess = true;
    },
  },
});

export const loginActions = loginSlice.actions;

export default loginSlice.reducer;
